import {TItemId} from 'src/constants';
import {EInvoiceKind, EInvoiceType} from 'src/containers/Invoices/definitions';
import {TBankDetails} from 'src/containers/User';

enum EAutopaymentStatus {
  NEW = 'NEW',
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED',
}

enum EAutopaymentError {
  INSUFFICIENT_FUNDS = 'INSUFFICIENT_FUNDS',
  CARD_DECLINE = 'CARD_DECLINE',
  GENERIC_DECLINE = 'GENERIC_DECLINE',
  AUTHENTICATION_REQUIRED = 'AUTHENTICATION_REQUIRED',
}

type TAutopaymentError = {
  occurredAt: string;
  nextAttemptAt: string;
  attemptsLeft: number;
  declineCode: EAutopaymentError;
  hostedInvoiceUrl: string;
};

type TStripeAutopayment = {
  threshold: number;
  amount: number;
  customerStatus: EAutopaymentStatus;
  paymentError?: TAutopaymentError;
  stripeUrl?: string;
};

type TAutopaymentRestrictions = {
  minimumThreshold: number;
  minimumAmount: number;
};

type TAutopaymentFormData = {
  threshold: number;
  amount: number;
};

type TGeneratePaymentLinkResponse = {downloadLink: string; amount: number; email: string};

type TGeneratePaymentLinkPayload = {
  tenantId?: TItemId;
  bankDetails?: TBankDetails;
  amount: number;
};

type TPayKeeperOrder = {
  orderId: number;
  clientId?: number;
  clientEmail?: string;
  serviceName?: string;
  paykeeperServerUrl: string;
};

type TPayKeeperInfo = {
  maskedCardNumber: string;
  errorDate?: string;
  userId?: number;
};

const MIN_PAYKEEPER_AMOUNT = 1_000;

const MAX_AMOUNT = 99_999;

const defaultStripeInvoiceParams = {
  type: EInvoiceType.DEFAULT,
  comment: '',
  // EStripeInvoiceKind.DUMMY для тестирования,
  // https://wiki.edna.ru/pages/viewpage.action?pageId=121014646
  kind: EInvoiceKind.STRIPE,
};

export {
  EAutopaymentStatus,
  EAutopaymentError,
  MAX_AMOUNT,
  MIN_PAYKEEPER_AMOUNT,
  defaultStripeInvoiceParams,
};
export type {
  TStripeAutopayment,
  TAutopaymentRestrictions,
  TAutopaymentFormData,
  TAutopaymentError,
  TPayKeeperOrder,
  TPayKeeperInfo,
  TGeneratePaymentLinkResponse,
  TGeneratePaymentLinkPayload,
};
